import { DEFAULT_PERSISTED_EXPORT_SETTINGS, toPanelSettings } from "../../../../../downloads/weekStaffScheduleExport/persistedSettings";

export type { WeekStaffScheduleExportSettings } from "../../../../../downloads/weekStaffScheduleExport/persistedSettings";

/**
 * What the panel shows before anything is loaded or when the API returned no settings at all.
 *
 * Derived from the persisted default rather than restated, so the panel, the JSONB column's server
 * default and the migration cannot drift. Anything genuinely panel-only (the hidden preferences
 * toggle) is added by `toPanelSettings`.
 */
export const DEFAULT_EXPORT_SETTINGS = toPanelSettings(DEFAULT_PERSISTED_EXPORT_SETTINGS);

/** Debounce before rebuilding the workbook, so dragging a number field doesn't rebuild per keystroke. */
export const PREVIEW_DEBOUNCE_MS = 250;

/**
 * Debounce before persisting a settings change. Long enough that flicking several toggles is one PUT,
 * short enough that closing the popup right after a change still saves it (pending saves also flush on
 * unmount). Matches how Management Center persists its settings.
 */
export const EXPORT_SETTINGS_SAVE_DEBOUNCE_MS = 3_000;
